import { defineMessages } from 'react-intl-next';

export const messages: {
	selectedStateColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	textColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	textTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	textTitle: {
		id: 'company-hub.links-menu-extension.text.title',
		defaultMessage: 'Text',
		description: 'Bolded text for the title of a section',
	},
	textColor: {
		id: 'company-hub.links-menu-extension.text.color',
		defaultMessage: 'Text color',
		description: 'Text labeling a customization option for text colors',
	},
	selectedStateColor: {
		id: 'company-hub.links-menu-extension.selected.state.color',
		defaultMessage: 'Selected state color',
		description: 'Text labeling a customization option for selected state colors',
	},
});
